import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef, useImperativeHandle, useState } from "react";
import appcolors from "../../constants/Colors";
import globalStyle from "../../globalStyle";
import GlobalButton from "../CustomButton";
import Label from "../Label";
import TextInput from "../TextInputs";
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2, 3),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

const StatusBlockDialog = forwardRef(({ onConfirm }, ref) => {
  const { t } = useTranslation(["common"]);
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState({});
  const [reason, setReason] = useState("");
  const [error, setError] = useState(false);
  const recieverEmail =
    dialogData.type === "Supplier"
      ? dialogData?.data?.businessEmail
      : dialogData?.data?.email;

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setDialogData(params);
      setOpen(true);
    },
    closeDialog() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setDialogData({});
    setReason("");
    setError(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="client-block-dialog-title"
      open={open}
    >
      <DialogTitle
        sx={{ m: 0, p: 2, textAlign: "center", color: "primary.main" }}
        id="client-block-dialog-title"
      >
        {t("doYouWantTo", {
          status: dialogData?.status,
          type: dialogData?.type,
        })}
      </DialogTitle>
      <DialogContent dividers>
        <Label labelText={t("provideReason")} required />
        <TextInput
          styleProps={{
            ...globalStyle.textField,
            "& .MuiOutlinedInput-root": {
              // padding: "0px !important",
            },
          }}
          placeholder={`10-200 ${t("words")}`}
          multiline
          rows={4}
          inputError={error}
          helperText={error && t("reasonIsRequired")}
          textLength={200}
          value={reason}
          onChange={(e) => {
            setError(false);
            setReason(e.target.value);
          }}
        />
        <Typography variant="body2" my={1}>
          <span style={{ color: appcolors.primary }}>{t("note")}:</span>{" "}
          {t("confirmationEmailSentTo", { email: recieverEmail })}.
        </Typography>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant="outlined"
          btnText="cancel"
          handleClickBtn={handleClose}
          styleProps={{
            height: 45,
          }}
        />
        <GlobalButton
          variant="contained"
          btnText="yes"
          styleProps={{
            height: 45,
          }}
          handleClickBtn={() => {
            if (!reason.trim()) {
              setError(true);
            } else {
              onConfirm({ ...dialogData, reason });
            }
          }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default StatusBlockDialog;
